/*
  Шапка карточки счёта: деньги, дело, должник — §3.3.5, §4.5.2.

  🔴 Переделана 25.09.2026 по макету, выбранному владельцем. До этого дня шапка
  была рядом из четырёх плиток - «К взысканию», «Ожидаемый возврат»,
  «Давность», «Стадия», - и на боевом счёте, где должник признал долг и получил
  ссылку, первый экран говорил «Ожидаемый возврат −1 071,91 ₽» и больше ничего.
  Цифра верна, но отвечает на вопрос «что даст суд», а читается как «деньги не
  вернутся»; ни признания, ни выданной ссылки, ни назначенных дат видно не
  было.

  Теперь одна карточка и три колонки в порядке вопросов, которые задают по
  счёту:

  1. **Деньги** - сколько должны, что даст суд и во что он обойдётся
     (`AccountMoney`);
  2. **Дело** - где счёт на дороге взыскания и какие даты его держат
     (`AccountRoad`);
  3. **Должник** - что он сказал и сделал (`AccountSignals`).

  Разложена на три файла не ради длины: у колонок разные источники - первая
  читает разбор счёта, вторая и третья резюме с сервера, - и правка одной не
  должна заставлять перечитывать остальные (§8.7).

  Пояснений текстом в шапке нет: они уехали под значок «i» - общий компонент
  `InfoHint`, тот же, что на отчётах и в исполнении. Само объяснение решения
  осталось кнопкой, а с 21.10.2026 стоит в шапке страницы под кнопками действий
  (`AccountWhy.jsx`): §4.5.2 требует, чтобы у каждой цифры было «из чего
  сложилось», и это требование о доступности объяснения, а не о том, что оно
  всегда развёрнуто.
*/

import AccountMoney from './AccountMoney.jsx'
import AccountRoad from './AccountRoad.jsx'
import AccountSignals from './AccountSignals.jsx'

export default function AccountSummary({ card }) {
  const triage = card.triage
  /*
    Резюме собирает сервер. Его может не быть только у ответа, снятого до
    правки от 25.09.2026, - тогда показываются деньги, а колонки дела и
    должника молчат, вместо того чтобы врать пустой дорогой.
  */
  const summary = card.summary

  return (
    <section className="summary">
      <AccountMoney
        triage={triage}
        accountId={card.account_id}
        debtPeriod={card.debt_period ?? null}
        debtSplit={card.debt_split ?? null}
      />
      {summary ? <AccountRoad summary={summary} /> : null}
      {summary ? <AccountSignals signals={summary.signals} /> : null}
    </section>
  )
}
